import React from 'react';
import { Route } from 'react-router-dom';

import ForgotPassword from 'common/components/Auth/ForgotPassword';
import { forgotPassword as forgotPasswordFn } from 'common/services/auth/api';

import Login from './Login';
import ResetPassword from './ResetPassword';
import ResetPasswordSuccess from './ResetPasswordSuccess';
import { AUTH_APP } from './service';

// Exported as a flat array of v6 <Route element="..."> entries so that the
// parent <Routes> in App.jsx can spread them in alongside other routes.
const routes = [
  <Route key="login" path="/login" element={<Login />} />,
  <Route
    key="forgot-password"
    path="/forgot-password"
    element={
      <ForgotPassword
        forgotPasswordFn={payload => forgotPasswordFn({ ...payload, type: AUTH_APP })}
      />
    }
  />,
  <Route key="reset-password" path="/reset-password" element={<ResetPassword />} />,
  <Route key="reset-password-onsite" path="/reset-password-onsite" element={<ResetPassword />} />,
  <Route
    key="reset-password-success"
    path="/reset-password-success"
    element={<ResetPasswordSuccess />}
  />,
];

export default routes;
